import { useMemo, createContext } from 'react';
import { matchPath } from 'react-router-dom';

import { isAdminSite } from '~/utils';

import { SHAREABLE_ROUTE_PREFIX_PATH } from '~/config/app.constants';

import type { TLocalAuthContext } from './types';
import useUserAuth from './hooks/useUserAuth';

import { adminAuthMapper, learnerAuthMapper } from './helpers/mapper';

const LocalAuthContext = createContext<TLocalAuthContext | undefined>(undefined);

function LocalAuthProvider({ children }: { children?: React.ReactNode }) {
  const auth = useUserAuth();

  let externalUserInteractionId: string | undefined;

  if (!auth.isLoggedIn) {
    const match = matchPath(SHAREABLE_ROUTE_PREFIX_PATH, window.location.pathname);
    externalUserInteractionId = match ? match.params.userInteractionId : undefined;
  }

  const value = useMemo(
    () =>
      isAdminSite()
        ? adminAuthMapper(auth, { externalUserInteractionId })
        : learnerAuthMapper(auth, { externalUserInteractionId }),
    [auth, externalUserInteractionId]
  );
  return <LocalAuthContext.Provider value={value}>{children}</LocalAuthContext.Provider>;
}

export { LocalAuthContext };
export default LocalAuthProvider;
